import * as React from 'react';
import { connect } from 'react-redux';
import styled from 'styled-components';

// Components
import { ContentContainer } from '../../../../components/Layout/ContentContainer';
import { Screen } from '../../../../components/Layout/Screen';
import Title, { Highlight } from '../../../../components/Title';
import TextBlock from '../../../../components/TextBlock';

// Assets
import { brandColors, device } from '../../../../styles/variables';
import ipad from '../../../../assets/images/pages/neva/neva_ipad.png';

const StyledScreen = Screen.extend`
  position: relative;
  overflow: hidden;
  background: ${brandColors.purple};
  padding-top: 1px;
  margin-top: -1px;

  .title {
    padding: 156px 0 0;
  }
`;

const Content = ContentContainer.extend`
  position: relative;
`;

const IPadPosition = styled.div`
  max-width: 388px;

  @media ${device.mobileL} {
    position: absolute;
    top: 50%;
    transform: translate(0, -50%);
    right: -43%;
    max-width: 500px;
  }

  @media ${device.tablet} {
    right: -58%;
    max-width: 766px;
  }

  @media ${device.laptop} {
    right: -40%;
    max-width: 921px;
  }
`;

const BespokeScreen = () => (
  <StyledScreen>
    <Content>
      <Title primary={false} className="title" color={brandColors.white}>
        Bespoke <Highlight>and</Highlight>
        <br />intuitive
      </Title>
      <br />
      <TextBlock width="382px" color={brandColors.white}>
        <p>
          We ended up with a bespoke learning management system, using TinCan with 7 interactive
          modules, 37 videos and an innovative search function for quick access to reference
          information pre-consultation.
        </p>
      </TextBlock>
      <IPadPosition>
        <img src={ipad} alt="neva ipad" />
      </IPadPosition>
    </Content>
  </StyledScreen>
);

export default connect()(BespokeScreen);



// WEBPACK FOOTER //
// ./src/pages/CaseStudies/MakingOfAnIndustryLeader/screens/Bespoke.jsx